(() => {
  'use strict';
  const root = (window.Shopify?.routes?.root || window.theme?.routes?.root || '/').replace(/\/?$/, '/');
  const popupKey = 'orvune-shared-cart-30min-v1', cartKey = popupKey;
  const deadlines = {};
  const accessories = ['15414735405135', '15414772269135'];
  let adding = false, redirecting = false, returnFocus = null, addedVariant = null;
  const dialog = () => document.getElementById('CrossSellPopup');
  function save(key, state) { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {} }
  function timerState(panel, key) {
    if (deadlines[key]) return deadlines[key];
    try { const saved = JSON.parse(sessionStorage.getItem(key) || 'null'); if (saved && Number.isFinite(saved.deadline)) deadlines[key] = saved; } catch (_) {}
    if (!deadlines[key]) { deadlines[key] = {deadline: Date.now() + 30 * 60000, redirected: false}; save(key, deadlines[key]); }
    return deadlines[key];
  }
  function checkout() {
    if (adding || redirecting) return;
    redirecting = true;
    window.location.assign(root + 'checkout');
  }
  function tick() {
    const popup = dialog();
    const panel = popup?.open ? popup.querySelector('[data-cross-sell][data-auto-checkout="true"]') : null;
    const drawer = document.getElementById('CartDrawer');
    const cartPanel = drawer?.classList.contains('is-open') ? drawer.querySelector('[data-cart-countdown]') : document.querySelector('main [data-cart-countdown]');
    if (!panel && !cartPanel) return;
    for (const [activePanel, key] of [[panel, popupKey], [cartPanel, cartKey]]) {
      if (!activePanel) continue;
      const state = timerState(activePanel, key), seconds = Math.max(0, Math.ceil((state.deadline - Date.now()) / 1000));
      const clock = String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0');
      if (activePanel.matches('[data-cross-sell]')) {
        activePanel.querySelector('[data-cross-sell-timer]').hidden = false;
        activePanel.querySelector('[data-cross-sell-clock]').textContent = clock;
      } else {
        const cartClock = activePanel.querySelector('[data-cart-clock]');
        cartClock.textContent = clock;
        cartClock.hidden = false;
        if (state.redirected) {
          const title = activePanel.querySelector('[data-cart-timer-title]');
          title.textContent = title.dataset.completed;
        }
      }
      if (!seconds && !state.redirected) { state.redirected = true; save(key, state); }
    }
  }
  function selectSummary() {
    dialog()?.querySelectorAll('[data-popup-item]').forEach(el => {el.hidden = el.dataset.popupItem !== String(addedVariant);});
  }
  window.theme.restoreCrossSellSummary = selectSummary;
  window.theme.openCrossSell = (item, trigger) => {
    const popup = dialog(), added = item?.items?.[0] || item;
    if (!popup || !window.HTMLDialogElement || !added || accessories.includes(String(added.product_id)) || !popup.querySelector('[data-cross-sell]')) return false;
    addedVariant = added.variant_id || added.id;
    if (!popup.querySelector('[data-popup-item="' + addedVariant + '"]')) return false;
    selectSummary(); returnFocus = trigger || document.activeElement;
    if (!popup.open) popup.showModal();
    document.body.classList.add('cross-popup-open');
    popup.scrollTop = 0; tick();
    popup.querySelector('[data-cross-popup-close]').focus();
    return true;
  };
  document.addEventListener('close', event => {
    if (event.target.id !== 'CrossSellPopup') return;
    document.body.classList.remove('cross-popup-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-cross-sell-variant]');
    if (!select) return;
    const card = select.closest('[data-cross-sell-card]'), cents = Number(select.selectedOptions[0].dataset.price);
    card.querySelector('[data-cross-sell-original]').textContent = window.theme.formatMoney(cents);
    card.querySelector('[data-cross-sell-price]').textContent = window.theme.formatMoney(cents);
  });
  document.addEventListener('click', async event => {
    const popup = dialog();
    if (event.target.closest('[data-cross-popup-close]') || event.target === popup) { if (!adding) popup.close(); return; }
    if (event.target.closest('[data-cross-sell-skip]')) { event.preventDefault(); checkout(); return; }
    const button = event.target.closest('[data-cross-sell-add]');
    if (!button || button.disabled || adding) return;
    event.preventDefault();
    const card = button.closest('[data-cross-sell-card]');
    const select = card.querySelector('[data-cross-sell-variant]');
    if (!select?.value) return;
    adding = true;
    popup.querySelectorAll('[data-cross-sell-add],[data-cross-sell-skip]').forEach(el => {el.disabled = true;});
    button.setAttribute('aria-busy', 'true');
    const error = popup.querySelector('[data-cross-sell-error]'); error.hidden = true;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message);
      await window.theme.refreshCart(); selectSummary();
      const nextAdd = [...popup.querySelectorAll('[data-cross-sell-add]')].find(el => !el.disabled);
      (nextAdd || popup.querySelector('[data-cross-sell-skip]')).focus();
    } catch (failure) {
      const liveError = popup.querySelector('[data-cross-sell-error]');
      liveError.textContent = failure.message || document.getElementById('CrossSellPopupContent').dataset.error;
      liveError.hidden = false;
    } finally {
      adding = false;
      button.removeAttribute('aria-busy');
      popup.querySelectorAll('[data-cross-sell-variant]').forEach(el => {
        const add = el.closest('[data-cross-sell-card]').querySelector('[data-cross-sell-add]');
        add.disabled = el.disabled || !el.selectedOptions[0] || el.selectedOptions[0].disabled;
      });
      popup.querySelectorAll('[data-cross-sell-skip]').forEach(el => {el.disabled = false;}); tick();
    }
  });
  setInterval(tick, 1000);
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) new MutationObserver(tick).observe(cartDrawer, {attributes:true, attributeFilter:['class']});
  window.addEventListener('pageshow', () => { redirecting = false; tick(); });
})();

